import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'components';
import ConditionalSpinner from 'components/ConditionalSpinner/ConditionalSpinner';
import * as Ui from './ModalFooter.styles';

const ModalFooter = ({
  children,
  onCancel,
  onSave,
  cancelText,
  saveText,
  isSaveDisabled = false,
  isSaveLoading = false,
  cancelVariant = 'white',
  saveVariant = 'primary',
}) => (
  <Ui.Footer>
    {children}
    <Ui.ButtonsWrapper>
      <Button variant={cancelVariant} type="button" className="rounded" onClick={onCancel}>
        {cancelText}
      </Button>
      <Button
        variant={saveVariant}
        type="submit"
        className="rounded"
        onClick={onSave}
        disabled={isSaveDisabled || isSaveLoading}
      >
        <ConditionalSpinner showSpinner={isSaveLoading}>{saveText}</ConditionalSpinner>
      </Button>
    </Ui.ButtonsWrapper>
  </Ui.Footer>
);

ModalFooter.propTypes = {
  children: PropTypes.node,
  onCancel: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  cancelText: PropTypes.string.isRequired,
  saveText: PropTypes.string.isRequired,
  isSaveDisabled: PropTypes.bool,
  isSaveLoading: PropTypes.bool,
  cancelVariant: PropTypes.string,
  saveVariant: PropTypes.string,
};

export default ModalFooter;
